import React from "react";
import "../../../../../../styles/ComponentsStyles/Operational/Academic/Exams/ExamDetails/ExamDetailsBodyForm.style.css";
import { FieldArray, Formik } from "formik";
import DropDownInput from "../../../../../Universal/DropDownInput.component";
import EyeIcon from "../../../../../../assets/Icons/Universal/EyeIcon.svg";
import DeleteButtonIcon from "../../../../../../assets/Icons/Universal/DeleteIcon.svg";
import EditButtonIcon from "../../../../../../assets/Icons/Universal/EditIcon.svg";
import LoaderIcon from "../../../../../../assets/Icons/Universal/LoaderIcon.svg";
const statusSelectTagColors = {
  completed: { color: "#54D77B", backgroundColor: "#54D77B24" },
  postponed: { color: "#FF9D00", backgroundColor: "#FF9D0024" },
  cancelled: { color: "#EC2658", backgroundColor: "#EC265824" },
};
const ExamDetailsBodyForm = () => {
  return (
    <table className="examDetailsBodyFormTable">
      <thead>
        <tr>
          <th>Date</th>
          <th>Add running invigilator</th>
          <th>Participants</th>
          <th>Change status</th>
          <th>Exam routine</th>
          <th>Actions</th>
        </tr>
      </thead>

      <tbody>
        <Formik
          initialValues={{
            rows: [
              {
                date: "27 Dec, 2024",
                invigilator: "",
                perticipatingClass: "Class 6",
                status: "Completed",
                examRouting: null,
              },
              {
                date: "27 Dec, 2024",
                invigilator: "",
                perticipatingClass: "Class 5",
                status: "Postponed",
                examRouting: null,
              },
              {
                date: "27 Dec, 2024",
                invigilator: "",
                perticipatingClass: "Class 8",
                status: "Postponed",
                examRouting: { routingUrl: "http://test.dsj" },
              },
              {
                date: "27 Dec, 2024",
                invigilator: "",
                perticipatingClass: "Class 10",
                status: "Cancelled",
                examRouting: { routingUrl: "http://test.dsj" },
              },
            ],
          }}
          onSubmit={(values) => console.log(values)}
          enableReinitialize
        >
          {({ values, setFieldValue }) => (
            <FieldArray name="rows">
              {() =>
                values?.rows.map((row, index) => {
                  // console.log();
                  return (
                    <tr key={index}>
                      <td>{row.date}</td>
                      <td>
                        <div style={{ width: "100%", paddingRight: "2rem" }}>
                          <DropDownInput
                            name={`rows.${index}.invigilator`}
                            suggestionList={[
                              "Teacher 1",
                              "Teacher 2",
                              "Teacher 3",
                            ]}
                            placeholder="Choose invigilator"
                            value={values?.rows[index].invigilator}
                            setFieldValue={(val) =>
                              setFieldValue(`rows.${index}.invigilator`, val)
                            }
                          />
                        </div>
                      </td>
                      <td>{row.perticipatingClass}</td>
                      {/* <td>{row.status}</td> */}
                      <td>
                        <select
                          name={`rows.${index}.status`}
                          className="examDetailsBodyFormTableStatusChangeSelectInput"
                          value={values?.rows[index].status}
                          style={{
                            backgroundColor:
                              statusSelectTagColors[
                                values?.rows[index]?.status?.toLowerCase()
                              ]?.backgroundColor,
                            color:
                              statusSelectTagColors[
                                values?.rows[index]?.status?.toLowerCase()
                              ]?.color,
                          }}
                          onChange={(e) =>
                            setFieldValue(
                              `rows.${index}.status`,
                              e.target.value
                            )
                          }
                        >
                          <option value="">Choose invigilator</option>
                          <option value="Completed">Completed</option>
                          <option value="Postponed">Postponed</option>
                          <option value="Cancelled">Cancelled</option>
                        </select>
                      </td>

                      <td>
                        {/* {row.examRouting} */}

                        {row?.examRouting && (
                          <button
                            className="blueActionBtnLight flex-row align-center g-05 t-12 poppins-medium text-no-wrap justify-center"
                            style={{
                              width: "150px",
                              border: "none",
                              height: "30px",
                              padding: 0,
                            }}
                          >
                            <img src={EyeIcon} alt="" />
                            <span className="t-12 poppins-medium text-no-wrap">
                              View
                            </span>
                          </button>
                        )}
                        {row?.examRouting === null && (
                          <button
                            className="blueActionBtnDark t-12 poppins-medium"
                            style={{
                              width: "150px",
                              height: "30px",
                              padding: 0,
                            }}
                          >
                            + Add routine
                          </button>
                        )}
                      </td>
                      <td>
                        {row?.examRouting && (
                          <div className="flex-row align-center justify-start g-1">
                            <button className="transparentBtn">
                              <img src={DeleteButtonIcon} alt="" />
                            </button>
                            <button className="transparentBtn">
                              <img src={EditButtonIcon} alt="" />
                            </button>
                          </div>
                        )}
                        {row?.examRouting === null && (
                          <img src={LoaderIcon} alt="no data added" style={{cursor:"not-allowed"}}/>
                        )}
                      </td>
                    </tr>
                  );
                })
              }
            </FieldArray>
          )}
        </Formik>
      </tbody>
    </table>
  );
};

export default ExamDetailsBodyForm;
